import React from 'react';
import Breadcrumb from '../components/Common/Breadcrumb';
import { Link } from 'react-router-dom';

const Training = () => {
  const trainings = [
    {
      id: 1,
      title: 'Visa Application Training',
      image: '/assets/img/training-1.jpg',
      description: 'Learn the complete process of visa application and documentation.',
      duration: '2 Days',
      price: '$299'
    },
    {
      id: 2,
      title: 'Interview Preparation',
      image: '/assets/img/training-2.jpg',
      description: 'Prepare for visa interviews with our expert guidance.',
      duration: '1 Day',
      price: '$199'
    },
    {
      id: 3,
      title: 'Documentation Workshop',
      image: '/assets/img/training-3.jpg',
      description: 'Understand all required documents and their preparation.',
      duration: '3 Days',
      price: '$399'
    },
    {
      id: 4,
      title: 'Legal Compliance',
      image: '/assets/img/training-4.jpg',
      description: 'Learn about legal requirements and compliance procedures.',
      duration: '2 Days',
      price: '$299'
    }
  ];

  return (
    <>
      <Breadcrumb title="Training Programs" />
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
            <div className="sub-style">
              <h5 className="sub-title text-primary px-3">Training</h5>
            </div>
            <h1 className="display-5 mb-4">Professional Training Programs</h1>
            <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat deleniti amet at atque sequi quibusdam cumque itaque repudiandae temporibus.</p>
          </div>
          <div className="row g-4">
            {trainings.map((training, index) => (
              <div key={training.id} className="col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.2}s`}>
                <div className="training-item">
                  <div className="training-img">
                    <img src={training.image} className="img-fluid w-100 rounded" alt={training.title} />
                  </div>
                  <div className="training-content p-4">
                    <h5 className="mb-3">{training.title}</h5>
                    <p className="mb-3">{training.description}</p>
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="text-muted">Duration: {training.duration}</span>
                      <span className="text-primary fw-bold">{training.price}</span>
                    </div>
                    <Link className="btn btn-primary rounded-pill mt-3" to="#">Enroll Now</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Training; 